import React from 'react';
import './About.css';
import AnimatedCow from './AnimatedCow';


const About = () => {
    return (
        <section id="about" className="about-section">
            <div className="container">

                <div className="about-content">
                    <h2 className="section-title text-center">Growing Together, Naturally</h2>

                    {/* Animated Cow Illustration */}
                    <div className="about-cow-container">
                        <AnimatedCow animation="idle" size="large" />
                    </div>

                    <div className="about-text">
                        <p>
                            At Growing Fields Organics, our work begins with soil.
                            We prepare organic compost and soil inputs on our own land, using natural decomposition, time, and biological processes — not chemicals or shortcuts.
                        </p>
                        <p>
                            Our focus is simple: restore soil health so plants can grow the way nature intended. Every product we make is something we use ourselves, tested in real soil before it reaches you.
                        </p>
                        <p>
                            Whether you are a farmer, gardener, or home grower, we believe healthy soil is the foundation of healthy growth — today and for the future.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
